export enum JobStatus {
  Pending    = 'Pending',
  InProgress = 'InProgress',  
  Completed  = 'Completed',
  Failed     = 'Failed'
}